export const VIEWPORT_ONCE = { once: true };
export const VIEWPORT_ONCE_TIGHT = { once: true, margin: "-60px" };
export const VIEWPORT_ONCE_WIDE = { once: true, margin: "-80px" };

export const staggerVariants = ({ x = 0, y = 0, duration = 0.5, step = 0.05 } = {}) => ({
    hidden: { opacity: 0, x, y },
    visible: (i = 0) => ({
        opacity: 1,
        x: 0,
        y: 0,
        transition: { duration, delay: i * step },
    }),
});

export const fadeVariants = ({ x = 0, y = 0, scale, duration = 0.6, delay = 0 } = {}) => ({
    hidden: { opacity: 0, x, y, ...(scale !== undefined && { scale }) },
    visible: {
        opacity: 1,
        x: 0,
        y: 0,
        ...(scale !== undefined && { scale: 1 }),
        transition: { duration, delay },
    },
});
